module.exports = __webpack_public_path__ + "static/media/ill_hudbesvar.f76f4244.svg";